import { z } from "zod";
import { ResponseAddress } from "../../shared/address.js";

const AddressType = z.enum(["businessAddress"]);

const EntityAddressResult = z.object({
  entityId: z.string(),
  addressType: AddressType,
  address: ResponseAddress.optional(),
});

export const Ok = z.object({
  items: z.array(EntityAddressResult),
});

export const Err = z.string();
